import * as THREE from "three";
import { colors } from "../../utils/colors";

const XMark = ({ windowCoordSystem, xMarkRef, xMarkPosition }) => {
  const uAxis = windowCoordSystem.uAxis;
  const vAxis = windowCoordSystem.vAxis;
  const normal = windowCoordSystem.normal;

  const matrix = new THREE.Matrix4();
  matrix.makeBasis(uAxis, vAxis, normal);

  const quaternion = new THREE.Quaternion();
  quaternion.setFromRotationMatrix(matrix);

  return (
    <group position={xMarkPosition} quaternion={quaternion} ref={xMarkRef}>
      <mesh rotation={[0, 0, Math.PI / 4]}>
        <boxGeometry args={[0.4, 0.05, 0.05]} />
        <meshBasicMaterial color={colors.red500()} />
      </mesh>
      <mesh rotation={[0, 0, -Math.PI / 4]}>
        <boxGeometry args={[0.4, 0.05, 0.05]} />
        <meshBasicMaterial color={colors.red500()} />
      </mesh>
    </group>
  );
};

export default XMark;
